import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withPermission, Roles } from "../../../util/PermissionProvider";
import ProductCategoryPage from "./ProductCategoryPage";
import ProductCategoryEditPage from "./ProductCategoryPage/editPage";
import ProductTagPage from "./ProductTagPage";
import ProductTagEditPage from "./ProductTagPage/editPage";
import TransactionListingPage from "./TransactionListingPage";
import TransactionEditPage from "./TransactionEditPage";
import ShippingEditPage from "./ShippingEditPage";
import ShippingListingPage from "./ShippingListingPage";
import EmailContentSettingPage from "./EmailContentSettingPage";
import EShopSettingPage from "./EShopSettingPage";
import ProductListingPage from "./ProductListingPage";
import ProductEditPage from "./ProductEditPage";

export default function EShopPages(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        path={`${match.url}/product-category/:id`}
        component={withPermission(
          ProductCategoryEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/product-category`}
        component={withPermission(
          ProductCategoryPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/product-tag/:id`}
        component={withPermission(
          ProductTagEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/product-tag`}
        component={withPermission(
          ProductTagPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/transaction/:id`}
        component={withPermission(
          TransactionEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/transaction`}
        component={withPermission(
          TransactionListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/shipping-setting/:id`}
        component={withPermission(
          ShippingEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />

      <Route
        path={`${match.url}/product/:id`}
        component={withPermission(
          ProductEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/shipping-setting`}
        component={withPermission(
          ShippingListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/product`}
        component={withPermission(
          ProductListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/email-content-setting`}
        component={withPermission(
          EmailContentSettingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/setting`}
        component={withPermission(
          EShopSettingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
